<template>
<v-container>
 <v-snackbar
  v-model="snackbar"
  :color="snackbarColor"
  :top="true"
  :right="true"
  :timeout="6000"
  >
  {{ message }}
  <v-btn
    dark
    text
    @click="snackbar = false"
  >
    CLOSE
  </v-btn>
 </v-snackbar>
 <v-layout mb-1>
      <v-flex xs12>
        <h2 class="white--text">NCE Reports </h2>
      </v-flex>
    </v-layout>
    <v-layout>
          <v-flex xs3>
        </v-flex>
        <v-spacer>
        </v-spacer>
        <v-col cols="12" md="2" class="text-lg-right">
      <v-menu offset-y >
<!--          <template v-slot:activator="{ on }">-->
<!--            <v-btn-->
<!--              color="secondary"-->
<!--              dark-->
<!--              v-on="on"-->
<!--              @click="exportToExcel"-->
<!--            >-->
<!--              Export Report-->
<!--            </v-btn>-->
<!--          </template>-->
      </v-menu>
    </v-col>
        </v-layout>
  <v-layout row wrap ml-3>
    <v-flex  fluid fill-height>
        <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="7">
        <v-card raised height="380" width="800" class="right-aligned-chart-item">
            <DxPieChart
      id="pie"
      :data-source="growers"
      palette="Bright"
      title="Growers Settlement Report"
      @point-click="pointClickHandler($event)"
      @legend-click="legendClickHandler($event)"
    >
      <DxSeries
        argument-field="grower"
        value-field="growercount"
      >
        <DxLabel :visible="true">
          <DxConnector
            :visible="true"
            :width="1"
          />
        </DxLabel>
      </DxSeries>
      <DxSize :width="600"/>
      <DxExport :enabled="true"/>
    </DxPieChart>
  </v-card>
        </v-col>
      </v-row>
      </v-flex>
  </v-layout>
<!-- <v-layout mt-200>
  <v-flex xs12 mt-200>
    <auctionfile-dash @updateAuctionFilesCount="updateAuctionFilesCount" v-show="uploadedAuctionFiles"></auctionfile-dash>
  </v-flex>
</v-layout> -->
<v-layout mt-200>
  <v-flex xs12 mt-200>
    <GrowersSettlementData v-show="showSettlementDetails" :segmentSelected="segmentSelected" :key="childComponentKey"></GrowersSettlementData>
  </v-flex>
</v-layout>
</v-container>
</template>

<script>
import axios from 'axios'
// import AuctionfileDash from './PaidUnpaidData'
import { mapActions } from 'vuex'
import config from '../../../config'
import GrowersSettlementData from './GrowersSettlementData'
import * as XLSX from 'xlsx'
import DxPieChart, {
	DxSize,
	DxSeries,
	DxLabel,
	DxConnector,
	DxExport
} from 'devextreme-vue/pie-chart'

export default {
	name: 'GrowersSettlementRpts',
	components: {
		// AuctionfileDash,
		DxPieChart,
		GrowersSettlementData,
		DxSize,
		DxSeries,
		DxLabel,
		DxConnector,
		DxExport
	},
	data: function () {
		return {
			message: '',
			snackbar: false,
			snackbarColor: '',
			showSettlementDetails: false,
			uploadedCatalogues: true,
			noOfCatalogues: 0,
			uploadedAuctionFiles: false,
			noOfAuctionFiles: 0,
			currentPage: 1,
			itemsPerPage: 10, // Set your desired items per page
			totalItems: 100, // Set the total number of items
			items: [{ name: 'auction', title: 'Auction File', ext: 'xlsx' }],
			growers: [],
			growerSettlements: [],
			deadline: '',
			segmentSelected: null,
			childComponentKey: 0
		}
	},
	mounted () {
		this.getSettlementGrowersDetails()
	},
	computed: {
		todaysDate: function () {
			const now = new Date()
			const options = {
				day: 'numeric',
				month: 'short',
				weekday: 'long',
				year: 'numeric'
			}
			return now.toLocaleString('en-us', options)
		},
		...mapActions({
			getNceTimeline: 'auction/getNceTimeline'
		})
	},
	methods: {
		exportToExcel () {
			const jsonData = this.growerSettlements
			var wb = XLSX.utils.book_new()
			const headings = [['E-SLIP', 'AMOUNT', 'WEIGHT', 'SALE NUMBER', 'SEASON', 'FIRSTNAME', 'LASTNAME', 'PHONE', 'USERNAME', 'ORGANIZATION CODE', 'ORGANIZATION NAME', 'EMAIL', 'ORGANIZATION TYPE NAME', 'STATUS']]
			var ws = XLSX.utils.json_to_sheet(jsonData, { origin: 'A2', skipHeader: true })
			XLSX.utils.sheet_add_aoa(ws, headings)
			XLSX.utils.book_append_sheet(wb, ws, 'Coffee-DSS-Report')
			XLSX.writeFile(wb, 'Growers-Settlement-Report-' + Date.now() + '.xlsx')
		},
		uploadedCataloguesTab () {
			this.uploadedCatalogues = true
			this.uploadedAuctionFiles = false
		},
		showSettlementDetailsTab () {
			this.showSettlementDetails = true
		},
		uploadedAuctionFilesTab () {
			this.uploadedCatalogues = false
			this.uploadedAuctionFiles = true
		},
		updateCatalogueCount (count) {
			this.noOfCatalogues = count
		},
		updateAuctionFilesCount (count) {
			this.noOfAuctionFiles = count
		},
		download (file) {
			const url = config.serverURI + '/files/download?filename=' + file.name
			axios({ url: url, method: 'GET', responseType: 'blob' })
				.then(response => {
					const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.ms-excel' }))
					const link = document.createElement('a')
					link.href = url
					const itemFileName = file.name + '_001_2018_2019.' + file.ext
					link.setAttribute('download', itemFileName)
					document.body.appendChild(link)
					link.click()
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = 'Error occurred'
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
		triggerGetNCETimeline () {
			this.getNceTimeline.then(response => {
				this.deadline = response.data
			}).catch(error => {
				console.log(error.response)
			})
		},
		pointClickHandler (e) {
			const arg = e.target
			this.segmentSelected = arg.data.trantype
			this.childComponentKey += 1
			this.showSettlementDetailsTab()

			if (arg.data.trantype === 'PENDINGSETTLEMENT') {

			} else if (arg.data.trantype === 'SETTLEDGROWERS') {

			} else if (arg.data.trantype === 'FAILEDGROWERCHARGES') {

			} else if (arg.data.trantype === 'SETTLEDGROWERCHARGES') {

			} else if (arg.data.trantype === 'FAILEDGROWERSETTLEMENT') {

			}
		},
		legendClickHandler (e) {
		},
		doesArrayContainKey (array, key) {
			// Using hasOwnProperty
			const hasKeyWithHasOwnProperty = array.some(obj => obj.hasOwnProperty(key))

			// Using 'in' operator
			const hasKeyWithInOperator = array.some(obj => key in obj)

			return hasKeyWithHasOwnProperty || hasKeyWithInOperator
		},
		getSettlementGrowersDetails () {
			const token = localStorage.getItem('token')
			const tokenconfig = { headers: { Authorization: `Bearer ${token}` } }
			// const withDet = config.serverURI + "/reports/findAllGrowersWithSettlementDetails";
			const allPayments = config.serverURI + '/reports/findAllPayments'
			// const withoutDet =
			//   config.serverURI + "/reports/findAllGrowersWithoutSettlementDetails";
			// const pendingApprov = config.serverURI + '/reports/findAllGrowersWithSettlementDetailsByStatus'

			const withSettlementDetails = axios.get(allPayments, { tokenconfig })
			// const withoutSettlementDetails = axios.post(withoutDet, { tokenconfig });
			// const pendingApproval =  axios.post (pendingApprov, { tokenconfig });

			axios
				.all([withSettlementDetails])
				.then(
					axios.spread((...responses) => {
						const responsewithDet = responses[0]
						const responsewithoutDet = responses[1]
						// const responespendingApprov = responses[2]

						console.log('responsewithDet', responsewithDet)
						// console.log("responsewithoutDet", responsewithoutDet);
						// console.log("responespendingApprov",responespendingApprov);
						// console.log("TEST: " + responsewithDet["data"][0].status.id)

						const paidSettledCounter = 0
						let paidCounter = 0
						const pendingCounter = 0
						const detailsErrorCounter = 0
						const settlementErrorCounter = 0
						let officeAccountCounter = 0
						const counter = 0
						const arr = responsewithDet.data

						let pendingSettlementCounter = 0
						let settledGrowersCounter = 0
						let failedGrowersChargesCounter = 0
						const failedGrowersSetlementCounter = 0
						this.growerSettlements = responsewithDet.data
						arr.forEach(result => {
							// console.log(result.status.id)

							const id = result.status.id

							switch (id) {
							case 40:
								paidCounter++
								break
							case 41:
								failedGrowersChargesCounter++
								break
							case 39:
								officeAccountCounter++
								break
							case 38:
								settledGrowersCounter++
								break
							case 6:
								pendingSettlementCounter++
								break
							}
						})

						console.log('PAID', paidCounter)

						console.log('FAILED GROWER CHARGES', failedGrowersChargesCounter)

						console.log('FAILED GROWER SETLEMENT', officeAccountCounter)

						console.log('SETTLED GROWER', settledGrowersCounter)

						console.log('PENDING SETTLEMENT', pendingSettlementCounter)

						// console.log("paidSettledCounter....." + paidSettledCounter)

						this.growers = [

							{
								grower: 'Pending Settlement',
								growercount: pendingSettlementCounter,
								trantype: 'PENDINGSETTLEMENT'
							},
							{
								grower: 'Settled Growers',
								growercount: settledGrowersCounter,
								trantype: 'SETTLEDGROWERS'
							},

							{
								grower: 'Failed Grower Charges',
								growercount: failedGrowersChargesCounter,
								trantype: 'FAILEDGROWERCHARGES'
							},

							{
								grower: 'Settled Grower Charges',
								growercount: paidCounter,
								trantype: 'SETTLEDGROWERCHARGES'
							},
							{
								grower: 'Failed grower settlement',
								growercount: settlementErrorCounter,
								trantype: 'FAILEDGROWERSETTLEMENT'
							},,

						]

						// console.log(Object.keys(responsewithDet.data).length);
					})
				)
				.catch((errors) => {
					console.log(errors)
				})
		}
	}
}
</script>
<style>
.right-aligned-chart {
  float: right;
  /* display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; */
}
.right-aligned-chart-item {
  float: center;
  /* display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; */
}

</style>
